import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikSetWheelSpeed extends ASTBlock {
    constructor(color) {
        super(color, "alvik_set_wheel_speed")
        this.predefinedInputs = {
            "speed": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            }
        }
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "dreh das %1 Rad %2 mit %3 % der Leistung %4",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "wheel_side",
                    "options": [
                        [
                            "linke",
                            "left"
                        ],
                        [
                            "rechte",
                            "right"
                        ]
                    ]
                },
                {
                    "type": "field_dropdown",
                    "name": "direction",
                    "options": [
                        [
                            "vorwärts",
                            "+"
                        ],
                        [
                            "rückwärts",
                            "-"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "speed",
                    "check": "Number"
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "previousStatement": null,
            "nextStatement": null,
            "inputsInline": true
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}